export function resolveConversationBotOff(
  utilisateur,
  apiBotOff = false,
  liveBotStates = {}
) {
  if (Object.prototype.hasOwnProperty.call(liveBotStates, utilisateur)) {
    return liveBotStates[utilisateur] === true;
  }

  return apiBotOff === true;
}
